import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-900"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7.808 10.995v-6.47a.5.5 0 0 0-1 0v6.47a1.075 1.075 0 0 0-.586.948 1.086 1.086 0 1 0 2.172 0 1.075 1.075 0 0 0-.586-.948z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M9.338 9.092V2.201a2.05 2.05 0 0 0-4.1 0v6.891a3.747 3.747 0 1 0 4.1 0zm-2.05 5.866a2.736 2.736 0 0 1-1.31-5.145l.26-.142v-7.47a1.05 1.05 0 0 1 2.1 0v7.47l.26.142a2.736 2.736 0 0 1-1.31 5.145zM13.437 1.92h-.5v-.5a.5.5 0 1 0-1 0v.5h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 1 0v-.5h.5a.5.5 0 0 0 0-1z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }